// extracted by mini-css-extract-plugin
export var radioInputRow = "t_rV";
export var radioInputColumn = "t_rW";
export var inputOptionRow = "t_qq";
export var inputOptionColumn = "t_qr";